import type { Locale } from '@backmarket/http-api'
import { toBcp47Locale } from '@backmarket/utils/string/toBcp47Locale'

export default function createDateFormatter(locale: Locale) {
  return (date: Date, options?: Intl.DateTimeFormatOptions) =>
    Intl.DateTimeFormat(toBcp47Locale(locale), options).format(date)
}
